/*eslint no-shadow-restricted-names: 0*/

import axios from 'axios';
import { setUserEmail, setUserName } from "../redux/modules/userData";
import store from "../redux/store";
import { Toast } from 'cx-ui-components';
import { isInIframe } from 'serenova-js-utils/browser';
import sdkConf from "../env.json";

let sdkConfig = sdkConf;

export function loadSdkConf() {
  const relativeUrl = window.location.href;
  let baseUrl = (relativeUrl.indexOf('index.html') > 0)
    ? relativeUrl.substring(0, relativeUrl.lastIndexOf('index.html'))
    : relativeUrl.substring(0, relativeUrl.lastIndexOf('#/'));
  if (baseUrl.indexOf('?') > 0) {
    baseUrl = baseUrl.substring(0, relativeUrl.lastIndexOf('?'));
  }
  axios({
    method: 'get',
    url: `${baseUrl}config.json?t=${Date.now()}`,
  }).then((res) => {
    if (typeof res.data !== 'undefined') {
      const version = res.data.config && res.data.config.version;
      if (window.Config2Conf !== undefined) {
        if (window.Config2Conf.version !== version) {
          clearInterval(versionCheck);
          // the isInIframe function returns the opposite
          if (isInIframe()) {
            reloadAfterChanges();
          } else {
            // window.parent.localStorage.setItem('newVersionAvailable', 'true');
            window.parent.postMessage({ Config2Conf: res.data.config }, '*');
          }
        } else if (isInIframe() && (localStorage.getItem("refreshDismiss") === 'true' || localStorage.getItem("newVersionAvailable") === 'true')) {
          reloadAfterChanges();
        }
      }
      window.Config2Conf = res.data.config;
    }
    if (typeof window.Config2Conf !== 'undefined' && typeof window.CxEngage.subscribe === 'undefined') {
      const sdkConf = {
        baseUrl: `https://${window.Config2Conf.api}`,
        environment: window.Config2Conf.env,
        logLevel: window.Config2Conf.logLevel,
        blastSqsOutput: window.Config2Conf.blastSqsOutput,
        reportingRefreshRate: window.Config2Conf.refreshRate,
      };
      sdkConfig = sdkConf;
      localStorage.setItem('ENV', window.Config2Conf.env);
      localStorage.setItem('wfm', window.Config2Conf.wfm);
      localStorage.setItem('refreshDismiss', 'false');
      CxEngage.initialize(sdkConf);
    }
  });
}

export function versionCheck() {
  // Cache busting version check every 5min
  return setInterval(loadSdkConf, 300000);
}

export function cxInit() {
  if (window.location.hostname === 'localhost' || window.location.hostname.includes('ngrok')) {
    if (window.self === window.top && CxEngage.initialize) {
      const sdkConf = require('../env.json');
      localStorage.setItem('ENV', sdkConf.environment);
      localStorage.setItem('wfm', sdkConf.wfm);
      localStorage.setItem('refreshDismiss', 'false');
      CxEngage.initialize(sdkConf);
    }
  } else {
    loadSdkConf();
    versionCheck();
  }
}

export function cxLogin(username, password, callback) {
  CxEngage.authentication.login(
    {
      username: username,
      password: password,
      // ttl is good to comment out to be able to test what
      // happens when authentication expires...
      // ttl in seconds
      // ttl: 60
    },
    (err, topic, response) => {
      if (err) {
        console.warn('ERROR WITH LOGIN', err);
        return callback(err);
      } else {
        return callback(response);
      }
    }
  );
}

export function cxTokenLogin(token, callback) {
  CxEngage.authentication.login({ token: token }, (err, topic, response) => {
    if (err) {
      console.warn('ERROR WITH LOGIN', err);
      return callback(err);
    } else {
      return callback(response);
    }
  });
}

export const cxSetTenant = (selectedTenant, callback) => {
  CxEngage.session.setActiveTenant({ tenantId: selectedTenant, noSession: true }, (err, topic, response) => {
    if (err) {
      console.warn('ERROR WITH TENANT SELECTION', err);
    } else {
      return callback(response);
    }
  });
}

export function cxResetPassword(userEmail) {
  axios({
    method: 'PUT',
    url: `${sdkConfig.baseUrl}request-password-reset`,
    data: {
      email: userEmail,
    },
    validateStatus: function (status) {
      return status;
    }
  }).then((response) => {
    if (response.status === 200 || response.status === 204)  {
      Toast.success('An email has been sent to the address provided with password reset instructions. If you do not receive an email shortly, check your spam folder and contact Support for assistance.');
    } else {
      const cause = response.data ? response.data : '';
      Toast.error('Request Password Reset Failed - ' + response.status + ': ' + cause);
    }
  });
}

export function cxGetUserName() {
  let urlParams = window.location.hash;
  urlParams = urlParams.replace('#/reset-password?', '');
  let container = {};
  urlParams
    .split('&')
    .toString()
    .split(',')
    .forEach((item) => {
      container[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        ? item.split('=')[1]
        : 'No query strings available';
    });
  const userId = container.userid ? container.userid : container.userId;
  let userName = '';
  axios({
    method: 'GET',
    url: `${sdkConfig.baseUrl}users/${userId}`,
    headers: { Authorization: `Token ${container.token}` },
    validateStatus: function (status) {
      return status;
    }
  }).then((response) => {
    if (response.status === 200)  {
      userName = response.data.result.firstName + ' ' + response.data.result.lastName;
    } else if (response.status === 401)  {
      Toast.info('Password Reset Token Expired');
      userName = 'no-username';
    } else {
      const cause = response.data ? response.data : '';
      Toast.error('Password Reset Failed - ' + response.status + ': ' + cause);
    }
    store.dispatch(
      setUserName(userName)
    );
  });
}

export function cxChangePassword(userPassword) {
  let urlParams = window.location.hash;
  urlParams = urlParams.replace('#/reset-password', '');
  let container = {};
  urlParams
    .split('&')
    .toString()
    .substring(1)
    .split(',')
    .forEach((item) => {
      container[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        ? item.split('=')[1]
        : 'No query strings available';
    });
  const userId = container.userid ? container.userid : container.userId;
  try {
    axios({
      method: 'PUT',
      url: `${sdkConfig.baseUrl}users/${userId}`,
      headers: { Authorization: `Token ${container.token}` },
      data: {
        password: userPassword,
      },
    });
    return true;
  } catch {
    console.warn('ERROR WITH resetting password');
    return false;
  }
}

export function cxGetUserEmail() {
  let urlParams = window.location.hash;
  urlParams = urlParams.replace('#/invite-accept', '');
  let container = {};
  urlParams
    .split('&')
    .toString()
    .substring(1)
    .split(',')
    .forEach((item) => {
      container[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        ? item.split('=')[1]
        : 'No query strings available';
    });
  const userId = container.userid ? container.userid : container.userId;
  let userEmail = '';
  axios({
    method: 'GET',
    url: `${sdkConfig.baseUrl}users/${userId}`,
    headers: { Authorization: `Token ${container.token}` },
    validateStatus: function (status) {
      return status;
    }
  }).then((response) => {
    if (response.status === 200)  {
      userEmail = response.data.result.email;
    } else if (response.status === 401)  {
      Toast.info('Sorry, this invitation has expired. Please contact your account administrator.');
      userEmail = 'no-userEmail';
    } else {
      const cause = response.data ? response.data : '';
      Toast.error('Invitation Failed - ' + response.status + ': ' + cause);
    }
    store.dispatch(
      setUserEmail(userEmail)
    );
  });
}

export function cxSubmitUserAccount(userFirstName, userLastName, userPassword, callback) {
  let urlParams = window.location.hash;
  urlParams = urlParams.replace('#/invite-accept', '');
  let container = {};
  urlParams
    .split('&')
    .toString()
    .substring(1)
    .split(',')
    .forEach((item) => {
      container[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        ? item.split('=')[1]
        : 'No query strings available';
    });
  const userId = container.userid ? container.userid : container.userId;
  axios({
    method: 'PUT',
    url: `${sdkConfig.baseUrl}users/${userId}`,
    headers: { Authorization: `Token ${container.token}` },
    data: {
      externalId: null,
      firstName: userFirstName,
      lastName: userLastName,
      password: userPassword,
    },
    validateStatus: function (status) {
      return status;
    }
  }).then((response) => {
    if (response.status === 200)  {
      Toast.success('Submit Success');
      cxUpdateUserAcceptedStatus(userPassword, callback);
    } else {
      const cause = response.data ? response.data : '';
      Toast.error('User Account Update Failed - ' + response.status + ': ' + cause);
    }
  });
}

export function cxUpdateUserAcceptedStatus(userPassword, callback) {
  let urlParams = window.location.hash;
  urlParams = urlParams.replace('#/invite-accept', '');
  let container = {};
  urlParams
    .split('&')
    .toString()
    .substring(1)
    .split(',')
    .forEach((item) => {
      container[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
        ? item.split('=')[1]
        : 'No query strings available';
    });
  const tenantId = container.tenantid ? container.tenantid : container.tenantId;
  const userId = container.userid ? container.userid : container.userId;
  axios({
    method: 'PUT',
    url: `${sdkConfig.baseUrl}tenants/${tenantId}/users/${userId}`,
    headers: { Authorization: `Token ${container.token}` },
    data: {
      status: 'accepted',
    },
    validateStatus: function (status) {
      return status;
    }
  }).then((response) => {
    if (response.status === 200)  {
      Toast.success('User Account Updated');
      cxLogin(response.data.result.email, userPassword, callback);
    } else {
      const cause = response.data ? response.data : '';
      Toast.error('User Account Update Failed - ' + response.status + ': ' + cause);
    }
  });
}

function reloadAfterChanges() {
  const message = '' +
    'There is a new version available! Click to refresh.' +
    '<br /><button id="refresh">Refresh</button>' +
    '<br /><button id="later">Later</button>';
  const title = undefined; //need it to be able to use the third parameter to override properties
  const options = {
    preventDuplicates: true,
    timeOut: '0',
    extendedTimeOut: '0',
    closeOnHover: false,
    tapToDismiss: false,
    closeButton: false,
  };

  const toastObject = Toast.info(message, title, options);
  toastObject?.delegate('#refresh', 'click', function () {
    location.reload(true);
    localStorage.setItem('refreshDismiss', 'false');
  })
  .delegate('#later', 'click', function () {
    localStorage.setItem('refreshDismiss', 'true');
    Toast.clear(toastObject, { force: true });
  });
}
